import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { PostsFragment } from '@/fragments/Posts'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  ${PostsFragment}
  query GetPost($databaseId: ID!, $asPreview: Boolean = false) {
    post(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      content
      seo {
        metaDesc
        title
      }
      date
      author {
        node {
          name
        }
      }
      authors {
        nodes {
          name
          authorFields {
            authorHeadshot {
              node {
                sourceUrl
                altText
              }
            }
          }
        }
      }
      tags {
        edges {
          node {
            name
            uri
          }
        }
      }
      categories {
        edges {
          node {
            name
            uri
          }
        }
      }
      ...FeaturedImageFragment
    }
    posts(first: 12) {
      nodes {
        ...PostsFeedItemFragment
      }
    }
  }
`
